<template>
  <div class="home_aside">
    <img src="../assets/logo.png" class="logo">
    <el-menu
        class="el-menu-vertical-demo"
        background-color="#34363a"
        text-color="#c1c1c1"
        active-text-color="#fff"
        router
        :unique-opened="true"
        @select="selectIndex"
        style="border-right: 1px #415348 solid"
        :default-active="atv"
    >
      <el-menu-item index="/home/workbench">
        <i class="el-icon-s-home"></i>
        <span style="margin-left:10px">首页</span>
      </el-menu-item>
      <el-submenu :index="menu1.index" v-for="(menu1,index) in menuList" :key="index">
        <template slot="title">
          <!--          <img :src="menu1.icon" alt style="width:16px"/>-->
          <i :class="menu1.icon"></i>
          <span style="margin-left:10px">{{ menu1.module_name }}</span>
        </template>
        <div v-for="(menu2,ind) in menu1.list" :key="ind">
          <el-menu-item-group v-if="!menu2.list">
            <el-menu-item
                :index="menu2.path"
            >{{ menu2.module_name }}
            </el-menu-item>
          </el-menu-item-group>
          <el-submenu :index="menu2.index" v-if="menu2.list" >
            <template slot="title">{{menu2.module_name }}</template>
            <el-menu-item  :index="menu3.path" v-for="(menu3,ind) in menu2.list" :key="ind">{{ menu3.module_name }}</el-menu-item>
          </el-submenu>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import guideList from "../service/guide.js";
export default {
  data() {
    return {
      menuList: [],
      atv:'',
    };
  },
  created() {
    this.getList();
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
        if(this.$route.matched.length>2)
        {
          this.atv=val.matched[2].path || val.matched[1].path
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    selectIndex(e) {
      this.$emit('selectIndex', e)
    },
    getList() {
      this.menuList = guideList;
    },
    matched(){
      if(this.$route.matched.length>2)
      {
        this.atv=this.$route.matched[2].path || this.$route.matched[1].path
      }
     
    }
  },
  mounted() {
    this.matched()
  },
};
</script>
<style lang="scss" scoped>
.home_aside {
  transition: 1.5s;
  height: 100%;
  overflow: scroll;
  box-sizing: border-box;
  background: #34363a;

  .logo {
    width: 96px;
    height: 20px;
    margin-left:50px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  .el-menu-item.is-active {
    background: #5a79ed !important;
  }
}

// 隐藏滚动条
.home_aside::-webkit-scrollbar {
  display: none;
}

.el-menu-item.is-active {
  background-color: rgb(52, 66, 58) !important;
}
</style>
<style>
.el-menu-item-group__title {
  padding: 0;
}
</style>